import React from "react";
import SectionTitle from "../../../components/section-title";
import Button from "../../../components/button";
import ServiceBox from "../../../components/service-box/box-left";
import ServiceBoxRight from "../../../components/service-box/box-right";
import ServiceBoxBottom from "../../../components/service-box/box-bottom";
import ServiceData from "../../../data/service.json";
import HomeData from "../../../data/home.json";
import PropTypes from "prop-types";

const ServiceListContainer = ({ classOption = "section-pb" }) => {
    return (
        <div className={`service-section position-relative ${classOption}`}>
            <div className="container">
                <div className="row mb-5 ">
                    <div className="col-xl-8 col-lg-8 mx-auto text-center">
                        <SectionTitle
                            classOption="title-section text-center mb-5"
                            subTitle=""
                            title="<h1><b>Business <span class='text-primary text-decoration-underline fst-italic'><a href='products'>Loans</a></span></b></h1>"
                            excerptClassOption="null"
                            excerpt="For retailers, manufacturers, traders, suppliers, service providers, dealers & distributors"
                        />
                    </div>
                </div>

                <div className="row mb-n7 align-items-center">
                    <div className="col-md-6 col-xl-4 mb-7">
                        <div className="service-media-wrapper media-spacing-left">
                            {HomeData[9].product &&
                                HomeData[9].product
                                    .slice(0, 3)
                                    .map((single, key) => {
                                        // {ServiceData &&
                                        //     ServiceData.slice(0, 3).map((single, key) => {
                                        if (single.id) {
                                            return (
                                                <ServiceBox
                                                    data={single}
                                                    key={key}
                                                    classOption={
                                                        "product-box-left-shadow"
                                                    }
                                                />
                                            );
                                        }
                                    })}
                        </div>
                    </div>

                    <div className="col-xl-4 mb-7 order-md-1 order-xl-0">
                        <div className="service-media-img text-center">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/banner/BusinessLoan.png`}
                                alt="Products"
                            />
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4 mb-7">
                        <div className="service-media-wrapper media-spacing-right">
                            {HomeData[9].product &&
                                HomeData[9].product
                                    .slice(4, 8)
                                    .map((single, key) => {
                                        if (single.id) {
                                            return (
                                                <ServiceBoxRight
                                                    data={single}
                                                    key={key}
                                                    classOption={
                                                        "product-box-right-shadow"
                                                    }
                                                />
                                            );
                                        }
                                    })}
                        </div>
                    </div>
                </div>
                <div className="row mb-10 mt-5">
                    <div className="col-md-6 col-xl-4 col-lg-4 mx-auto text-center">
                        {HomeData[9].product &&
                            HomeData[9].product
                                .slice(3, 4)
                                .map((single, key) => {
                                    if (single.id) {
                                        return (
                                            <ServiceBoxBottom
                                                data={single}
                                                key={key}
                                                classOption={
                                                    "product-box-bottom-shadow"
                                                }
                                            />
                                        );
                                    }
                                })}
                    </div>
                </div>
                <div className="row mb-5 mt-5">
                    <div className="col-xl-8 col-lg-8 mx-auto text-center">
                        <Button
                            classOption="btn btn-xm btn-primary btn-hover-primary"
                            text="Product Details"
                            link={process.env.PUBLIC_URL + "/products"}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

ServiceListContainer.propTypes = {
    classOption: PropTypes.string,
};

export default ServiceListContainer;
